import {
    FETCH_MODULES_REQUEST,
    FETCH_MODULES_SUCCESS,
    FETCH_MODULES_FAILURE,
    ADD_MODULE_REQUEST,
    ADD_MODULE_SUCCESS,
    ADD_MODULE_FAILURE,
    UPDATE_MODULE_REQUEST,
    UPDATE_MODULE_SUCCESS,
    UPDATE_MODULE_FAILURE,
    DELETE_MODULE_REQUEST,
    DELETE_MODULE_SUCCESS,
    DELETE_MODULE_FAILURE,
  } from './actionTypes';
  
  const initialState = {
    modules: [],
    loading: false,
    error: null,
  };
  
  const moduleReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MODULES_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case FETCH_MODULES_SUCCESS:
        return {
          ...state,
          loading: false,
          modules: action.payload,
        };
  
      case FETCH_MODULES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case ADD_MODULE_REQUEST:
      case UPDATE_MODULE_REQUEST:
      case DELETE_MODULE_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case ADD_MODULE_SUCCESS:
        return {
          ...state,
          loading: false,
          modules: {
            ...state.modules,
            data: [action.payload?.data,...state.modules?.data],
          },
        };
  
      case ADD_MODULE_FAILURE:
      case UPDATE_MODULE_FAILURE:
      case DELETE_MODULE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_MODULE_SUCCESS:
        return {
          ...state,
          loading: false,
          modules: {
            ...state.modules,
            data: state.modules?.data?.map((item) =>
              item?._id == action.payload?.data?._id ? action.payload.data : item
            ),
          },
        };
  
      case DELETE_MODULE_SUCCESS:
        return {
          ...state,
          loading: false,
          modules: {
            ...state.modules,
            data: state.modules?.data?.filter(
              (item) => item?._id !== action.payload?.data?._id
            ),
          },
        };
  
      default:
        return state;
    }
  };
  
  export default moduleReducer;
  